import * as React from "react";

export const LearningIcon = ({ props }: any) => {
  return (
    <svg width={31} height={31} viewBox="0 0 31 31" fill="none" {...props}>
      <rect
        x={0.5}
        y={0.5}
        width={30}
        height={30}
        rx={7.5}
        stroke="#4C5CFB"
        strokeOpacity={0.1}
      />
      <path
        d="M9.666 20.396a1.77 1.77 0 011.77-1.771H21"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.437 8h9.562v14.167h-9.562a1.77 1.77 0 01-1.771-1.771V9.77A1.77 1.77 0 0111.436 8v0z"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
